function EmptyState({ icon = null, title, description = '', action = null, className = '' }) {
  const rootClass = ['empty-state', className].filter(Boolean).join(' ');
  return (
    <div className={rootClass}>
      <div className="empty-state__icon" aria-hidden="true">
        {icon || <span className="empty-state__icon-fallback">...</span>}
      </div>
      <p className="empty-state__title">{title}</p>
      {description ? <p className="empty-state__description">{description}</p> : null}
      {action ? <div className="empty-state__action">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
